import { focusedElementBeforeMenu, menus, menuOverlay, menuToggles } from './_vars'
import openMenu from './open'

/**
 * Create click listeners for buttons that open the menu.
 */
const init = () => {
  if ( menuToggles && menus && menuOverlay )
    menuToggles.forEach( menuToggle =>
      menuToggle.addEventListener( 'click', () => {
        const menuToOpen = menuToggle.dataset.openMenu
        if ( menuToOpen ) openMenu( focusedElementBeforeMenu, menuOverlay, menuToggle, menuToOpen )
      } )
    )
}

export default init
